import { Box, Theme, createStyles, makeStyles, styled } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';

export const MainCont = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '0 20px',
}));

export const CategoryHeader = styled(Box)(() => ({
  fontSize: 25,
  marginBottom: 10,
  marginTop: 20,
}));

export const GroupContainer = styled(Box)(() => ({
  marginBottom: 50,
}));

export const MapCont = styled(Box)(() => ({}));

export const GroupHeader = styled(Box)(() => ({
  fontSize: 16,
  color: '#3e8bff',
  borderBottom: 'solid 1px #2d343e',
  paddingBottom: 10,

  marginBottom: 30,
  marginRight: 20,
  display: 'flex',
  alignItems: 'center',
}));

export const SkillContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gridColumnGap: '20px',
  gridRowGap: '30px',
  [theme.breakpoints.down(2000)]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.down(1650)]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down(700)]: {
    gridTemplateColumns: 'unset',
  },
}));

export const InitialsBox = styled('div')(() => ({
  backgroundColor: '#3e8bff',
  width: 15,
  height: 16,
  borderRadius: 3,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 1,
  cursor: 'help',
  marginRight: 10,
}));

export const ControlCont = styled('div')<Theme, { isSelected?: boolean }>(({ isSelected, theme }: any) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  color: 'white',
  backgroundColor: isSelected
    ? theme.palette.type === 'dark'
      ? 'rgb(24, 33, 46)'
      : COLORS.LIGHT_BACKGROUND
    : 'transparent',
  padding: isSelected ? 10 : 0,
  borderRadius: 5,
  marginBottom: isSelected ? -15 : 0,
}));

export const ProficiencyCont = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
}));

export const ActiveBorder = styled('div')(() => ({
  // backgroundColor: 'rgb(24, 33, 46)',
  borderRadius: 10,
  width: '95%',
  height: 68,
  position: 'absolute',
  left: -10,
}));

export const CheckboxContainer = styled('div')({
  letterSpacing: 0.4,

  '& .MuiTypography-root': {
    fontSize: 15,
  },

  '&.MuiFormControlLabel-root': {
    margin: 0,
  },
});

export const Heading = styled(Typography)({
  position: 'relative',
  borderBottom: '1px solid #2d343e',
  alignItems: 'center',
  paddingBottom: 15,
  margin: '10px 0 30px',
  color: COLORS.PRIMARY,

  '&::before': {
    content: '""',
    background: '#3e8bff',
    height: '1px',
    position: 'absolute',
    width: 42,
    bottom: '-1px',
  },
});

// New Styles
export const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      '& .MuiSelect-icon': {
        color: (theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK) + '!important', // Change this to your desired color,
      },
    },
    option: {
      '&:hover': {
        backgroundColor: theme.palette.type === 'dark' ? '' : COLORS.LIGHT_BACKGROUND,
      },
      '&[data-focus="true"]': {
        backgroundColor: theme.palette.type === 'dark' ? '' : COLORS.LIGHT_BACKGROUND,
      },
    },
    toolTip: {
      background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
    },
  }),
);
